import React, { createContext, useReducer, useContext, ReactNode } from 'react';

export enum ConceptGroupsDialogActionType {
  OPEN_DIALOG = 'OPEN_DIALOG',
  CLOSE_DIALOG = 'CLOSE_DIALOG',
}

export enum DialogType {
  DETAILS = 'details',
  DELETE = 'delete',
}

type ConceptGroupsListDialogState = {
  activeDialog: DialogType | null;
  data?: { conceptGroupId: string } | null;
};

type ConceptGroupsListDialogAction =
  | {
      type: ConceptGroupsDialogActionType.OPEN_DIALOG;
      activeDialog: DialogType | null;
      data?: { conceptGroupId: string } | null;
    }
  | { type: ConceptGroupsDialogActionType.CLOSE_DIALOG };

const initialState: ConceptGroupsListDialogState = {
  activeDialog: null,
  data: null,
};

const ConceptGroupsListDialogContext = createContext<{
  state: ConceptGroupsListDialogState;
  dispatch: React.Dispatch<ConceptGroupsListDialogAction>;
}>({
  state: initialState,
  dispatch: () => null,
});

const dialogReducer = (
  state: ConceptGroupsListDialogState,
  action: ConceptGroupsListDialogAction
): ConceptGroupsListDialogState => {
  switch (action.type) {
    case ConceptGroupsDialogActionType.OPEN_DIALOG:
      return { ...state, activeDialog: action.activeDialog, data: action.data ?? null };
    case ConceptGroupsDialogActionType.CLOSE_DIALOG:
      return { ...state, activeDialog: null, data: null };
    default:
      return state;
  }
};

export const ConceptGroupsListDialogProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(dialogReducer, initialState);

  return (
    <ConceptGroupsListDialogContext.Provider value={{ state, dispatch }}>
      {children}
    </ConceptGroupsListDialogContext.Provider>
  );
};

export const useConceptGroupsListDialogContext = () => useContext(ConceptGroupsListDialogContext);
export { DialogType as ConceptGroupsDialogType };
